<!-- File: src/components/Gestao/Relatorios/Receitas/ReceitasRecebidasRecebimento.vue -->

<template>
  <div>
    <!-- MODO “TELA NORMAL”: formulário + botão -->
    <div v-if="!printMode">
      <h6>Receitas Recebidas – Por Data de Recebimento</h6><p></p>
      <div class="row mb-3">
        <div class="col-auto">
          <label>Data Início:</label>
          <input type="date" v-model="dataInicioLocal" class="form-control" />
        </div>
        <div class="col-auto">
          <label>Data Fim:</label>
          <input type="date" v-model="dataFimLocal" class="form-control" />
        </div>
        <div class="col-auto align-self-end">
          <button @click="abrirPrint" class="btn btn-primary">
            Executar
          </button>
        </div>
      </div>
    </div>

    <!-- MODO “IMPRESSÃO/PRINT”: exibe somente tabela de Receitas Recebidas -->
    <div v-else>
      <p class="text-center" style="font-size: 14px;">
        ( {{ globalUtils.formatarData(dataInicio) }} a {{ globalUtils.formatarData(dataFim) }} )
      </p>

      <div v-if="loading">Carregando…</div>
      <div v-else>
        <!-- Tabela de Receitas Recebidas -->
        <div v-if="receitas.length">
        <h6>Receitas Recebidas</h6>
          <table class="table table-striped mb-2">
            <thead>
              <tr>
                <th>Vencimento</th>
                <th>Pagamento</th>
                <th>Prev. Receb.</th>
                <th class="text-right">Valor</th>
                <th>Refil – Plano de Contas</th>
                <th>Descrição</th>
                <th>Forma de Pagamento</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in receitas" :key="'rec-' + idx">
                <td>{{ globalUtils.formatarData(item.vencimento) }}</td>
                <td>{{ globalUtils.formatarData(item.pagamento) }}</td>
                <td>{{ globalUtils.formatarData(item.recebimento) }}</td>
                <td class="text-right">{{ formatarMoeda(item.valor) }}</td>
                <td>{{ item.refil }}</td>
                <td>{{ item.descricao }}</td>
                <td>{{ item.forma_pagamento }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="2"><strong>Total</strong></td>
                <td class="text-right">
                  <strong>{{ formatarMoeda(totais.valor) }}</strong>
                </td>
                <td colspan="3"></td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div v-else>
          <p class="text-muted">Nenhuma receita recebida para este período.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'
import globalUtils from '@/utils/globalUtils.js'

const props = defineProps({
  printMode:  { type: Boolean, default: false },
  dataInicio: String,
  dataFim:    String,
  printTitle: { type: String, default: 'Relatório' },
  subtitle:   { type: String, default: '' }
})

const router = useRouter()

// Estados locais (modo “tela normal”)
const dataInicioLocal = ref('')
const dataFimLocal    = ref('')

// Estados do resultado (modo “print”)
const loading  = ref(false)
const receitas = ref([])
const totais   = ref({})

// Se estivermos em printMode, buscar os dados já no onMounted
onMounted(async () => {
  if (!props.printMode) return
  if (!props.dataInicio || !props.dataFim) return

  loading.value = true
  try {
    const res = await axios.get(
      '/gestao/relatorios/receitas/receitas-recebidas-recebimento',
      {
        params: {
          dataInicio: props.dataInicio,
          dataFim:    props.dataFim
        }
      }
    )
    // A resposta vem em { receitas: [...], totais: { valor: 1234.56 } }
    receitas.value = Array.isArray(res.data.receitas) ? res.data.receitas : []
    totais.value   = res.data.totais || {}
  } catch (e) {
    console.error('Erro ao buscar receitas recebidas:', e)
    receitas.value = []
    totais.value   = {}
  } finally {
    loading.value = false
  }
})

// Função chamada ao clicar em “Executar” (modo normal)
function abrirPrint() {
  if (!dataInicioLocal.value || !dataFimLocal.value) return

  const inicioFormatado = globalUtils.formatarData(dataInicioLocal.value)
  const fimFormatado    = globalUtils.formatarData(dataFimLocal.value)
  const subtitle        = `( ${inicioFormatado} a ${fimFormatado} )`

  router.push({
    path: `/gestao/relatorios/print/receitas-recebidas-recebimento`,
    query: {
      title:      'Receitas Recebidas – Por Data de Recebimento',
      dataInicio: dataInicioLocal.value,
      dataFim:    dataFimLocal.value,
      subtitle:   subtitle
    }
  })
}

// Formata valor numérico para moeda brasileira
function formatarMoeda(num) {
  if (num == null) return ''
  return Number(num).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}
.text-right {
  text-align: right !important;
}
</style>
